<div
  class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-sm duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold" i18n="@@subProductsTableTitle">Product Sub-Products</h2>
  </div>
  <div class="flex items-center justify-end">
    <div class="flex items-center gap-2">
      <a
        [routerLink]="['/admin/products/add-sub-product', productId()]"
        class="bg-primary hover-bg-primary-hover flex items-center justify-center gap-1 rounded-[8px] px-[10px] py-[5px] text-[13px] font-[500] text-[white] hover:cursor-pointer">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
        </svg>
        <span i18n="@@adminSubproductAddButton">Add Sub Product</span>
      </a>
    </div>
  </div>

  <app-sub-products-filter
    [filters]="filters()"
    (onApply)="applyFilters()"
    (onReset)="resetFilters()"
    (onSortToggle)="toggleSort()"></app-sub-products-filter>

  <div
    class="bg-white py-4 transition-all"
    [class.min-h-[400px]]="loading() || error() || subProducts().length === 0"
    [class.flex]="loading() || error() || subProducts().length === 0"
    [class.items-center]="loading() || error() || subProducts().length === 0"
    [class.justify-center]="loading() || error() || subProducts().length === 0">
    @if (loading()) {
      <app-loading></app-loading>
    } @else if (error()) {
      <app-error-data
        title="Failed to load sub-products"
        i18n-title="@@errorTitle"
        description="Something went wrong while fetching the data. Please try again."
        i18n-description="@@errorDesc"
        [showRetry]="true"
        (retry)="loadSubProducts()"></app-error-data>
    } @else if (subProducts().length === 0) {
      <app-empty-data
        title="No sub-products found matching your criteria"
        i18n-title="@@subProductsEmptyTitle"
        description="Try adjusting your filters or check back later when new sub-products are added."
        i18n-description="@@noSubProductsFoundAr"
        (retry)="loadSubProducts()"></app-empty-data>
    } @else {
      <app-sub-products-list
        [productId]="productId()"
        [data]="subProducts()"
        [isLoading]="loading()"
        [total]="totalItems()"
        [currentPage]="(filters().pageNum ?? 0) + 1"
        [pageSize]="filters().pageSize ?? 25"
        (pageChange)="handlePageChange($event)"></app-sub-products-list>
    }
  </div>
</div>
